import type { ComponentMeta } from "@mijalowcode/types";
import { ComponentCategory, PropType } from "@mijalowcode/types";

export const ResultMeta: ComponentMeta = {
  componentName: "Result",
  package: "@mijadesign/web",
  title: "结果页",
  description: "展示处理结果",
  category: ComponentCategory.FEEDBACK,
  icon: "CheckCircleOutlined",
  canHaveChildren: false,
  props: [
    {
      name: "status",
      label: "状态",
      type: PropType.ENUM,
      defaultValue: "info",
      options: [
        { label: "成功", value: "success" },
        { label: "信息", value: "info" },
        { label: "警告", value: "warning" },
        { label: "错误", value: "error" },
        { label: "403", value: "403" },
        { label: "404", value: "404" },
        { label: "500", value: "500" },
      ],
      group: "基础",
    },
    {
      name: "title",
      label: "标题",
      type: PropType.STRING,
      group: "基础",
    },
    {
      name: "subTitle",
      label: "副标题",
      type: PropType.STRING,
      group: "基础",
    },
  ],
  defaultProps: {
    status: "info",
    title: "操作成功",
  },
  npm: {
    package: "@mijadesign/web",
    exportName: "Result",
  },
  snippet: {
    componentName: "Result",
    package: "@mijadesign/web",
    props: { status: "success", title: "操作成功" },
  },
};
